import React from 'react';
import PropTypes from 'prop-types';
import StripeDefs from 'components/stripe-defs';
import SvgImage from 'components/svg-image';
import SvgText from 'components/svg-text';
import * as Mask from 'constants/mask';
import {getTranslate} from 'utils/attribute-util';
import {getBarStyle} from 'utils/style-util';
import {truncate} from 'common/utils/string-util';
import {isValid} from 'validators/number-validator';
import styles from './index.css';

const CHAR_TO_PIXEL_MOD = 0.125;

export default class Bar extends React.Component {
  static propTypes = {
    active: PropTypes.bool,
    detailIcon: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    detailLabel: PropTypes.string,
    height: PropTypes.number,
    label: PropTypes.string,
    mask: PropTypes.oneOf(Object.values(Mask)),
    padding: PropTypes.number,
    parentWidth: PropTypes.number,
    style: PropTypes.object,
    width: PropTypes.number,
    x: PropTypes.number,
    y: PropTypes.number,
  };

  static defaultProps = {
    active: false,
    detailIcon: '',
    detailLabel: '',
    height: 0,
    label: '',
    mask: '',
    padding: 10,
    parentWidth: 10,
    style: {},
    width: 0,
    x: 0,
    y: 0,
  };

  getContentLabelY(height, detailLabel, detailIcon) {
    if (isValid(height)) {
      const divisor = detailLabel || detailIcon ? 3 : 2;
      return Math.round(height / divisor);
    }
    return 0;
  }

  getDetailLabelY(height) {
    if (isValid(height)) {
      return Math.round((height / 3) * 2) + 2;
    }
    return 0;
  }

  getMaskID(mask, maskID) {
    return mask === Mask.STRIPE ? maskID : null;
  }

  render() {
    const {label, parentWidth} = this.props;
    const contentLabelY = this.getContentLabelY(
      this.props.height,
      this.props.detailLabel,
      this.props.detailIcon,
    );
    const detailY = this.getDetailLabelY(this.props.height);
    const maskID = this.getMaskID(this.props.mask, StripeDefs.getMaskID());
    const style = getBarStyle(
      this.props.active,
      this.props.style.fill,
      this.props.style.fillActive,
      maskID,
    );
    const translate = getTranslate(this.props.x, this.props.y);
    const detailTranslate = getTranslate(this.props.padding, detailY);
    let labelWidth = label ? label.length / CHAR_TO_PIXEL_MOD : 0;
    if (labelWidth >= parentWidth) {
      labelWidth = parentWidth;
    }
    return (
      <g className={styles.Bar} transform={translate}>
        {this.props.width > 0 ? (
          <rect
            className={styles.BarFill}
            height={this.props.height}
            style={style}
            width={this.props.width}
          />
        ) : null}

        {this.props.label ? (
          <SvgText
            className={styles.BarContentLabel}
            text={truncate(this.props.label, labelWidth * CHAR_TO_PIXEL_MOD)}
            x={this.props.padding}
            y={contentLabelY}
          />
        ) : null}

        {this.props.detailIcon || this.props.detailLabel ? (
          <g ref={(node) => (this._detail = node)} transform={detailTranslate}>
            {this.props.detailIcon ? (
              <SvgImage
                className={styles.BarDetailIcon}
                height={20}
                url={this.props.detailIcon}
                width={20}
                y={-10}
              />
            ) : null}

            {this.props.detailLabel ? (
              <SvgText
                className={styles.BarDetailLabel}
                text={this.props.detailLabel}
                x={this.props.detailIcon ? 20 : 0}
                y={0}
              />
            ) : null}
          </g>
        ) : null}
      </g>
    );
  }
}
